import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  protected sidebar = false;
  protected sidebarState$ = new BehaviorSubject(this.sidebar);
  constructor() { }

  toggleSidebar() {
    this.sidebarState$.next(!this.sidebarState$.getValue());
  }

  getSidebarStates(): Observable<boolean> {
    return of(this.sidebar);
  }

  onSidebarState(): Observable<boolean> {
    return this.sidebarState$.asObservable();
  }
}
